export default __webpack_public_path__ + "static/media/arrow-right-green.a89c39bb.svg";